<ng-container *transloco="let convert;">
  <div data-test-id="success-message-container" id="{{id}}" class="success-message-container" aria-live="assertive" tabindex="-1" #container>
    <i class="allycon-success-fill text-success" aria-hidden="true"></i>
    <span data-test-id="success-message-content" class="success-message-content"> {{ message }}</span>
    @if (goToLink) {
      <button
        data-test-id="success-message-go-to-link-button"
        data-track-elem="button"
        data-track-name="goToLink"
        class="btn btn-link p-0 goToLink position-relative"
        (click)="goTo()"
        [attr.aria-label]="convert('profileManagement.successMessage.ariaLabelMyAlert')"
        >
        {{goToLink}}
      </button>
    }
    @if (goToLink) {
      <strong>.</strong>
    }
    @if (closeButton) {
      <button
        data-test-id="success-message-close-button"
        data-track-elem="icon"
        data-track-name="Close"
        data-track-trigger="close"
        class="drawer__close"
        [attr.aria-label]="convert('common.btnClose')"
        (click)="cancel()">
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>
    }
  </div>
</ng-container>